import { IUserMilestone } from '../../IUserMilestone';

/**
 * Set when retailer dismisses any Sale related announcement
 * @deprecated
 */
export const SALE_ANNOUNCEMENT_DISMISSED =
  'SALE_ANNOUNCEMENT_DISMISSED' as IUserMilestone.RetailerMilestone;

export const Extensions = {
  deprecated: true,
};
